// extracted by mini-css-extract-plugin
export var errorBanner = "_gm-2";
export var scroller = "_gm-0";
export var thinking = "_gm-1";
export var visuallyHidden = "_gm-3";